import { ARBITRUM, BSC, BESC } from "./chains";

// Proxied through Vite dev server (/mexc → localhost:8008/api/mexc) to avoid
// Safari cross-origin blocking. In production, nginx proxies the same path.
export const MEXC_API_URL = "/mexc";
// CoinGecko OHLCV proxy for BESC-native tokens (BESC/WBESC, MONEY) not on MEXC.
export const COINGECKO_API_URL = "/coingecko";

const INDEXER_BASE_URL = (import.meta.env.VITE_INDEXER_API as string | undefined) ?? "http://localhost:8011";

const BACKEND_URLS = {
  default: "https://money-server-mainnet.uw.r.appspot.com",

  // [BSС_MAINNET]: "https://gambit-server-staging.uc.r.appspot.com",
  [ARBITRUM]: "https://money-server-mainnet.uw.r.appspot.com",
  [BSC]: "https://money-ron-server.uc.r.appspot.com",
  [BESC]: INDEXER_BASE_URL,
};

export function getServerBaseUrl(chainId: number) {
  if (!chainId) {
    throw new Error("chainId is not provided");
  }

  if (document.location.hostname.includes("deploy-preview")) {
    const fromLocalStorage = localStorage.getItem("SERVER_BASE_URL");
    if (fromLocalStorage) {
      return fromLocalStorage;
    }
  }

  return BACKEND_URLS[chainId] || BACKEND_URLS.default;
}

export function getServerUrl(chainId: number, path: string) {
  return `${getServerBaseUrl(chainId)}${path}`;
}
